import { render, staticRenderFns } from "./PendingApprovalCaseModal.vue?vue&type=template&id=48fce157"
import script from "./PendingApprovalCaseModal.vue?vue&type=script&lang=js"
export * from "./PendingApprovalCaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports